// extracted by mini-css-extract-plugin
export default {"container":"ContentContainer_container__VCOGq","title":"ContentContainer_title__3LKFj","mobile":"ContentContainer_mobile__M4mV1"};